import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

// runCounter is a solution to handle a nasty case that is caused
// by framer motion. We use Framer Motion to switch between pages
// which has an effect of the old page being unmounted after the new page is mounted.
// We expect this order of operations when we go from Page A to Page B:
//  - Page A unmounts
//  - Page B mounts
// However, because of the animation, page B mounts, then we run the animation,
// and then page A unmounts. Which results in the cleanup function of Page A
// running after the mount of Page B, which means that the title is set to the
// default title - as on every unmount we reset the title.
//
// To combat this, we use a counter that is incremented every time the component mounts.
// Now, when page A unmounts, it checks if the counter is less than the current counter.
// If it is, it means that page B has already mounted, so we don't reset the title.
let runCounter = 0

function setPageTitle(title: string, counter: number) {
  if (counter < runCounter) return
  document.title = title
}

export function PageTitle({ title }: { title: string }) {
  const { t } = useTranslation()
  const runRef = useRef(false)
  useEffect(() => {
    if (runRef.current) {
      // If this effect has already run, we don't need to do anything
      return
    }
    runCounter++
    const thisCounter = runCounter * 1
    const breakoutLearningName = t('breakout_learning')
    setPageTitle([title, breakoutLearningName].join(' | '), runCounter)
    return () => {
      setPageTitle(breakoutLearningName, thisCounter)
    }
  }, [t, title])

  return null
}
